<div class="flow-datepicker" style="width: 100%;">

  @if (showInput) {
    <div (click)="openDatepicker()" class="datepicker-container" style="cursor: pointer; width: 100%;">
      <flw-input 
        [value]="formattedValue" 
        [icon]="icon" 
        icon-position="end" 
        [disabled]="disabled" 
        [readOnly]="true"
        style="pointer-events: none; width: 100%; --width: 100%;">
        <ng-content></ng-content>
      </flw-input>
    </div>
  }

  <ion-content>
    <ion-modal class="datepicker-modal" #datepickerModal>
      <ng-template>
        <ion-datetime
          [value]="value?.toISOString()"
          [cancelText]="'lbl_cancel' | translate"
          [doneText]="'lbl_accept' | translate"
          [firstDayOfWeek]="1"
          presentation="date"
          [locale]="locale"
          showDefaultButtons="true"
          (ionChange)="handleChange($event)"
          [max]="max?.toISOString()"
        ></ion-datetime>
      </ng-template>
    </ion-modal>
  </ion-content>

</div>